export const emptyKeys = { all: false, keys: new Set() };

export const getColCount = (gapWidth: number, swatchWidth?: number, rootWidth?: number) => {
  if (!swatchWidth || !rootWidth) return 0;

  // if we have n swatchs, we have n-1 gaps
  const colCount = Math.floor((rootWidth + gapWidth) / (gapWidth + swatchWidth));
  return Math.max(1, colCount);
};
